/**
 * DS Cross-Sell Reminder – Cart Drawer
 * Shows a cross-sell reminder (e.g. "Passende Leine dazu") in the Apple Header Cart Pane.
 * Fetches fresh data via Section Rendering API after each cart change.
 * V1: Color-matched variant, discount price, one-click add, GA4.
 * Depends on: sections/ds-cross-sell-reminder-data.liquid
 */
(function() {
  'use strict';

  var SECTION_ID = 'ds-cross-sell-reminder-data';
  var SELECTOR = '[data-ds-cross-sell-reminder]';
  var CONFIG_SELECTOR = '[data-ds-cross-sell-reminder-config]';

  /* ── Read initial config ── */
  function readConfig() {
    var el = document.querySelector(CONFIG_SELECTOR);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  var currentConfig = readConfig();

  /* ── Helpers ── */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function ga4(event, params) {
    if (typeof gtag === 'function') gtag('event', event, params || {});
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function(k) {
        if (k === 'style' && typeof attrs[k] === 'object') {
          Object.keys(attrs[k]).forEach(function(sk) { node.style[sk] = attrs[k][sk]; });
        } else if (k === 'textContent') {
          node.textContent = attrs[k];
        } else {
          node.setAttribute(k, attrs[k]);
        }
      });
    }
    if (children) {
      children.forEach(function(c) { if (c) node.appendChild(c); });
    }
    return node;
  }

  /* ── Build DOM ── */
  function buildDOM(cfg) {
    if (!cfg) return null;

    // Price nodes
    var priceNodes = [];
    if (cfg.discountPercent > 0) {
      priceNodes.push(el('span', {
        style: { textDecoration: 'line-through', color: '#86868b', fontSize: '12px', marginRight: '4px' },
        textContent: formatMoney(cfg.originalPrice)
      }));
      priceNodes.push(el('span', {
        style: { fontWeight: '600', color: '#1d1d1f' },
        textContent: formatMoney(cfg.discountedPrice)
      }));
      priceNodes.push(document.createTextNode(' '));
      priceNodes.push(el('span', {
        style: { color: '#0071e3', fontSize: '11px', fontWeight: '500' },
        textContent: '-' + cfg.discountPercent + '%'
      }));
    } else {
      priceNodes.push(el('span', {
        style: { fontWeight: '600', color: '#1d1d1f' },
        textContent: formatMoney(cfg.originalPrice)
      }));
    }

    var priceDiv = el('div', { style: { marginTop: '2px', fontSize: '13px' } }, priceNodes);

    var img = el('img', {
      src: cfg.image,
      alt: cfg.title,
      width: '56',
      height: '56',
      loading: 'lazy',
      style: { width: '56px', height: '56px', borderRadius: '8px', objectFit: 'contain', background: '#fff', border: '1px solid #e5e5e5' }
    });

    var imgLink = el('a', { href: cfg.url, style: { flexShrink: '0' } }, [img]);

    var titleLink = el('a', {
      href: cfg.url,
      textContent: cfg.title,
      style: { fontSize: '13px', color: '#1d1d1f', textDecoration: 'none', lineHeight: '1.3', display: 'block' }
    });

    var infoNodes = [titleLink];
    // Opt-in-Text des Ziels (ds_cross.text), nur wenn gesetzt (VG-2609-3AFF3)
    if (cfg.text) {
      infoNodes.push(el('div', {
        textContent: cfg.text,
        style: { fontSize: '12px', color: '#6e6e73', lineHeight: '1.35', marginTop: '2px' }
      }));
    }
    infoNodes.push(priceDiv);
    var info = el('div', { style: { flex: '1', minWidth: '0' } }, infoNodes);

    var addBtn = el('button', {
      'data-ds-cs-reminder-add': '',
      textContent: 'Hinzuf\u00FCgen',
      style: {
        flexShrink: '0', border: 'none', background: '#1d1d1f', color: '#fff',
        fontSize: '12px', fontWeight: '500', padding: '8px 14px', borderRadius: '20px',
        cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', transition: 'opacity 150ms'
      }
    });

    var body = el('div', {
      style: { display: 'flex', gap: '10px', alignItems: 'center' }
    }, [imgLink, info, addBtn]);

    var headline = el('div', {
      textContent: cfg.headline,
      style: { fontSize: '12px', fontWeight: '600', color: '#1d1d1f', marginBottom: '8px' }
    });

    var wrapper = el('div', {
      'data-ds-cross-sell-reminder': '',
      style: {
        margin: '8px 0', padding: '12px', background: '#fff',
        border: '1px solid #e5e5e5', borderRadius: '10px', fontFamily: 'inherit'
      }
    }, [headline, body]);

    // Bind add button
    addBtn.addEventListener('click', function() {
      addBtn.textContent = '...';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-DS-Source': 'cross-sell-reminder' },
        body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        ga4('ds_cross_sell_add', {
          cross_sell_source: 'cart_drawer',
          cross_variant_id: cfg.variantId,
          discount_percent: cfg.discountPercent
        });

        // Collapse with success feedback
        addBtn.textContent = '\u2713';
        addBtn.style.background = '#0071e3';
        setTimeout(function() {
          wrapper.style.transition = 'opacity 300ms, max-height 300ms';
          wrapper.style.opacity = '0';
          wrapper.style.maxHeight = '0';
          wrapper.style.overflow = 'hidden';
          wrapper.style.margin = '0';
          wrapper.style.padding = '0';
          setTimeout(function() { wrapper.remove(); }, 300);
        }, 600);

        // Trigger cart refresh
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { items: [{ id: cfg.variantId }] }
        }));
      })
      .catch(function(err) {
        console.error('[ds-cross-sell-reminder] Add error:', err);
        addBtn.textContent = 'Fehler';
        setTimeout(function() { addBtn.textContent = 'Hinzuf\u00FCgen'; addBtn.disabled = false; }, 2000);
      });
    });

    return wrapper;
  }

  /* ── Inject into Apple Header Cart Pane ── */
  function inject(cfg) {
    // Remove existing reminder
    var existing = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < existing.length; i++) existing[i].remove();

    if (!cfg) return;

    // Abwahl auf der Produktseite respektieren (GF-Weisung 05.08.2026).
    // Der Umschalter dort steht auf AN. Wer ihn ausschaltet, hat das Angebot
    // samt Rabatt gesehen und abgelehnt. Dann hier nichts mehr zeigen.
    // Geschrieben wird der Schluessel in assets/ds-cross-sell.js, Frist 30 Tage.
    try {
      var abgewaehlt = JSON.parse(localStorage.getItem('dsCsAbgewaehlt') || '{}');
      var stempel = cfg.productId && abgewaehlt[cfg.productId];
      if (stempel && (Date.now() - stempel) < 30 * 24 * 60 * 60 * 1000) return;
    } catch (e) { /* privater Modus: dann eben anzeigen */ }

    // Dedup: suppress if same product as current upsell
    var upsellEl = document.querySelector('[data-ds-upsell-product-id]');
    if (upsellEl && cfg.productId) {
      var upsellPid = parseInt(upsellEl.getAttribute('data-ds-upsell-product-id'), 10);
      if (upsellPid === cfg.productId) return;
    }

    var node = buildDOM(cfg);
    if (!node) return;

    // Target: Apple Header Cart Pane content area
    var cartList = document.querySelector('#sn-cart-content-area .sn-cart-list');
    if (cartList && cartList.parentNode) {
      cartList.parentNode.insertBefore(node, cartList.nextSibling);
    } else {
      // Fallback: before existing upsell in legacy cart drawer
      var legacyUpsell = document.querySelector('[data-ds-upsell]');
      if (legacyUpsell && legacyUpsell.parentNode) {
        legacyUpsell.parentNode.insertBefore(node, legacyUpsell);
      }
    }
  }

  /* ── Fetch fresh config via Section Rendering API ── */
  function fetchFreshConfig(callback) {
    fetch('/?sections=' + SECTION_ID)
      .then(function(res) { return res.json(); })
      .then(function(sections) {
        var html = sections[SECTION_ID];
        if (!html) { callback(null); return; }

        // Parse the JSON config from the returned HTML using DOMParser (safe)
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var cfgEl = doc.querySelector(CONFIG_SELECTOR);
        if (!cfgEl) { callback(null); return; }

        try {
          callback(JSON.parse(cfgEl.textContent));
        } catch(e) {
          callback(null);
        }
      })
      .catch(function() { callback(null); });
  }

  /* ── Event Listeners ── */
  document.addEventListener('ajaxProduct:added', function() {
    setTimeout(function() {
      fetchFreshConfig(function(cfg) {
        currentConfig = cfg;
        inject(cfg);
      });
    }, 300);
  });

  document.addEventListener('cart:rendered', function() {
    inject(currentConfig);
  });

  /* ── MutationObserver for Apple Header Cart Pane ── */
  var cartArea = document.getElementById('sn-cart-content-area');
  if (cartArea) {
    var observer = new MutationObserver(function() {
      if (!document.querySelector(SELECTOR) && currentConfig) {
        inject(currentConfig);
      }
    });
    observer.observe(cartArea, { childList: true, subtree: true });
  }

  /* ── Initial inject ── */
  if (currentConfig) {
    setTimeout(function() { inject(currentConfig); }, 100);
  }
})();
